import { togglReportsApi } from '../../../services/togglReportsApi';
import { TogglTimeEntry } from '../../../types/toggl-api';

export default class TimeEntriesLoader {
  private apiKey: string;
  private readonly workspaceIds: number[];
  private readonly userId: number;
  private readonly pageSize = 500;
  private readonly generator: AsyncGenerator<TogglTimeEntry[], void, undefined>;
  private readonly start: string;
  private readonly stop: string;

  constructor(
    apiKey: string,
    workspaceIds: number[],
    userId: number,
    start: string,
    stop: string
  ) {
    this.generator = this.fetchTimeEntries();
    this.apiKey = apiKey;
    this.workspaceIds = workspaceIds;
    this.userId = userId;
    this.start = start;
    this.stop = stop;
  }

  async *fetchTimeEntries() {
    for (const workspaceId of this.workspaceIds) {
      yield* this.getTimeEntriesForWorkspace(workspaceId, this.userId);
    }
  }

  async *getTimeEntriesForWorkspace(
    workspaceId: number,
    userId: number,
    startAt = 1
  ): AsyncGenerator<TogglTimeEntry[], void, undefined> {
    const batch = await togglReportsApi(this.apiKey).getTimeEntries(
      workspaceId,
      userId,
      this.start,
      this.stop,
      this.pageSize,
      startAt
    );
    yield batch;

    if (batch.length) {
      yield* this.getTimeEntriesForWorkspace(
        workspaceId,
        startAt + batch.length
      );
    }
  }

  [Symbol.asyncIterator]() {
    return this.generator;
  }

  next() {
    return this.generator.next();
  }
}
